import { render, staticRenderFns } from "./IndagineEpidemiologicaRosoliaCongenitaEditComponent.vue?vue&type=template&id=72e0c196"
import script from "./IndagineEpidemiologicaRosoliaCongenitaEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaRosoliaCongenitaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports